<template>
    <vx-card :title='$t("Vehicles")'>
        <vs-table ref="table" v-model="selected" @selected="handleSelected" pagination :max-items="50" search :data="vehicles">

            <div slot="header" class="flex flex-wrap-reverse items-center flex-grow justify-between">

                <div v-if="$checkPermission(1601)" class="flex flex-wrap-reverse items-center">
                    <vs-button type="border" color="success" icon-pack="feather" icon="icon-plus-circle" @click="addVehiclePrompt = true">{{$t("Add")}}</vs-button>
                </div>

                <vs-dropdown vs-trigger-click class="cursor-pointer mb-4 mr-4">
                    <div class="p-4 border border-solid d-theme-border-grey-light rounded-full d-theme-dark-bg cursor-pointer flex items-center justify-between font-medium">
                        <span class="mr-2">{{ currentPage * itemsPerPage - (itemsPerPage - 1) }} - {{ vehicles.length - currentPage * itemsPerPage > 0 ? currentPage * itemsPerPage : vehicles.length }} of {{ vehicles.length }}</span>
                        <feather-icon icon="ChevronDownIcon" svgClasses="h-4 w-4" />
                    </div>

                    <vs-dropdown-menu>

                        <vs-dropdown-item @click="itemsPerPage=10">
                            <span>10</span>
                        </vs-dropdown-item>
                        <vs-dropdown-item @click="itemsPerPage=20">
                            <span>20</span>
                        </vs-dropdown-item>
                        <vs-dropdown-item @click="itemsPerPage=50">
                            <span>50</span>
                        </vs-dropdown-item>
                        <vs-dropdown-item @click="itemsPerPage=100">
                            <span>100</span>
                        </vs-dropdown-item>
                    </vs-dropdown-menu>
                </vs-dropdown>
            </div>

            <template slot="thead">
                <vs-th sort-key="name">{{$t("Name")}}</vs-th>
                <vs-th sort-key="registration">{{$t("Registration")}}</vs-th>
            </template>

            <template slot-scope="{data}">
                <tbody>
                <vs-tr :data="tr" :key="index" v-for="(tr, index) in data">

                    <vs-td :data="data[index].name">
                        {{ data[index].name }}
                    </vs-td>

                    <vs-td :data="data[index].registration">
                        {{ data[index].registration }}
                    </vs-td>

                </vs-tr>
                </tbody>
            </template>

        </vs-table>

        <vs-popup :title="$t('Add')" :active.sync="addVehiclePrompt">
            <div>
                <p class="mt-6">{{$t("Name")}}</p>
                <vs-input v-model="addName" style="width: 100%"></vs-input>
                <p class="mt-6">{{$t("User")}}</p>
                <vs-select class="w-full" autocomplete v-model="selectedUser">
                    <vs-select-item :key="index" :value="item.id" :text="item.name" v-for="(item,index) in $store.getters.companyUsers" />
                </vs-select>
                <p class="mt-6">{{$t("Vehicle")}}</p>
                <vs-select class="w-full" autocomplete v-model="selectedUserVehicle">
                    <vs-select-item :key="index" :value="item.id" :text="item.name" v-for="(item,index) in selectedUserVehicles" />
                </vs-select>
                <p class="mt-6">{{$t("Registration")}}</p>
                <vs-input disabled v-model="addRegistration" style="width: 100%"></vs-input>
                <vs-divider/>
                <vs-button color="success" type="border" class="mt-6; mr-1" @click="addVehicle">{{$t("Add")}}</vs-button>
            </div>
        </vs-popup>
    </vx-card>
</template>
<script>

    export default {
        data() {
            return {
                selected: {},
                vehicles: [],

                itemsPerPage: 20,
                isMounted: false,
                selectedUser: 0,
                selectedUserVehicle: 0,
                selectedUserVehicles: [],

                addVehiclePrompt: false,

                addName: '',
                addRegistration: '',
            }
        },
        computed: {
            currentPage() {
                if(this.isMounted) {
                    return this.$refs.table.currentx
                }
                return 0
            },
        },
        methods: {
            handleSelected(tr) {
                if(!this.$checkPermission(1601)) return;
                this.$router.push({ name: 'atVehicle', params: { id: tr.id } })
            },
            updateVehicles() {
                const thisIns = this;
                this.$http.get('/api/artificial_transport/v1/vehicle/')
                    .then(function (response) {
                        thisIns.vehicles = response.data;
                    })
                    .catch(function (error) {
                        thisIns.$vs.notify({
                            title:'Error',
                            text: error,
                            color:'danger',
                            iconPack: 'feather',
                            icon:'icon-alert-circle'})
                    });
            },
            addVehicle() {
                const thisIns = this;
                this.$http.post('/api/artificial_transport/v1/vehicle/', {
                    name: thisIns.addName,
                    registration: thisIns.addRegistration,
                    real_vehicle_id: thisIns.selectedUserVehicle
                }).then(function () {
                    thisIns.updateVehicles();
                    thisIns.addVehiclePrompt = false;
                    thisIns.addName = "";
                    thisIns.addRegistration = "";
                }).catch(function (error) {
                    thisIns.addVehiclePrompt = false;
                    thisIns.$vs.notify({
                        title:'Error',
                        text: error.response.data,
                        color:'danger',
                        iconPack: 'feather',
                        icon:'icon-alert-circle'})
                });
            },
        },
        watch: {
            selectedUser(){
                const thisIns = this;
                this.$http.get('/api/v1/user/' + this.selectedUser + "/vehicles")
                .then(function (response) {
                    thisIns.selectedUserVehicles = response.data;
                }).catch(function (error) {
                    thisIns.$vs.notify({
                        title:'Error',
                        text: error.response.data,
                        color:'danger',
                        iconPack: 'feather',
                        icon:'icon-alert-circle'})
                });
            },
            selectedUserVehicle(){
                for(let x = 0; x < this.selectedUserVehicles.length; x++){
                    if(this.selectedUserVehicles[x].id === this.selectedUserVehicle){
                        this.addRegistration = this.selectedUserVehicles[x].registration;
                    }
                }

            }
        },
        created() {
            this.updateVehicles()
        },
        mounted() {
            this.isMounted = true;
        },
        beforeRouteLeave (to, from, next) {
            if(this.addVehiclePrompt){
                this.addVehiclePrompt = false;
                next(false)
            }else{
                next()
            }
        }
    }
</script>
